module.exports = __webpack_public_path__ + "img/02_tone_1200.1ba63c64.png";